import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { DocumentsByProcessType, DocumentsByUser, Statistics, TimelineData } from '../../common/types/types';
import { useEffect, useState } from 'react';
import { display } from 'html2canvas/dist/types/css/property-descriptors/display';
import { fontStyle } from 'html2canvas/dist/types/css/property-descriptors/font-style';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

interface Props {
  statistics: Statistics | TimelineData | DocumentsByUser | DocumentsByProcessType | undefined;
  title: string;
  // docsByUsers: DocumentsByUser | undefined;
  //   graphData: string;
}

export const LineGraph = ({ statistics, title }: Props) => {
  const [data, setData] = useState({
    labels: [''],
    datasets: [
      {
        label: 'Number of documents',
        data: [0],
        borderColor: 'rgb(75,192,192)',
      },
      // {
      //   label: 'Zeljka',
      //   data: [0],
      //   borderColor: 'rgb(75,192,192)',
      // },
      // {
      //   label: 'Ivana',
      //   data: [0],
      //   borderColor: 'rgb(75,192,192)',
      // },
    ],
  });

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: title,
        font: {
          size: 24,
          family: 'ManropeRegular',
        },
      },
    },
  };

  useEffect(() => {
    setData({
      labels: statistics ? Object.keys(statistics) : [''],
      datasets: [
        {
          label: 'Number of documents',
          data: statistics ? Object.values(statistics) : [0],
          borderColor: '#228BE6',
        },
        // {
        //   label: 'Zeljka',
        //   data: docsByUsers?.zeljka ? Object.values(docsByUsers.zeljka) : [0],
        //   borderColor: '#228BE6',
        // },
        // {
        //   label: 'Ivana',
        //   data: docsByUsers?.ivana ? Object.values(docsByUsers.ivana) : [0],
        //   borderColor: '#228BE6',
        // },
      ],
    });
  }, [statistics]);

  return (
    <div className='line-graph font-h5-regular'>
      <Line options={options} data={data} />
    </div>
  );
};
